import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from 'src/app/service/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/service/common.service';
import { MessageComponent } from '../../dialog-box/message/message.component';

@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.scss']
})
export class ActivationComponent implements OnInit {
  activationForm!: FormGroup;
  isSubmitted: boolean = false;
  url: string = '';
  userId: string = '';
  btnLabel: string = '';
  iconClass: string = '';
  constructor(private fb: FormBuilder, private dialog: MatDialog,
    private loader: LoaderService,
    private router: Router,
    private restService: RestService,
    private translate: TranslateService, private route: ActivatedRoute,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.activationForm = this.fb.group({
      comments: [],
      block: [false],
      unBlock: [false],
      unlock: [false],
      unlockComments: [],
      deactivate: [false],
      deactivateComments: []
    })
    this.route.url.subscribe(url => {
      this.url = url[0].path;
    });
    this.route.params.subscribe((params) => {
      this.userId = params['userID']
    }
    )
    this.customValidation()
    this.getBtnLable()
  }

  customValidation() {
    if (this.url === 'user-block') {
      this.activationForm.get('block')?.setValidators([Validators.requiredTrue])
      this.activationForm.get('comments')?.setValidators([Validators.required])
      this.activationForm.get('unlock')?.clearValidators()
      this.activationForm.get('unlockComments')?.clearValidators()
      this.activationForm.get('deactivate')?.clearValidators()
      this.activationForm.get('deactivateComments')?.clearValidators()
      this.activationForm.get('unBlock')?.clearValidators()
    }
    if (this.url === 'user-unblock') {
      this.activationForm.get('unBlock')?.setValidators([Validators.requiredTrue]);
      this.activationForm.get('comments')?.setValidators([Validators.required])
      this.activationForm.get('block')?.clearValidators();
      this.activationForm.get('unlock')?.clearValidators()
      this.activationForm.get('unlockComments')?.clearValidators()
      this.activationForm.get('deactivate')?.clearValidators()
      this.activationForm.get('deactivateComments')?.clearValidators()

    }
    if (this.url === 'user-unlock') {
      this.activationForm.get('unlock')?.setValidators([Validators.requiredTrue]);
      this.activationForm.get('unlockComments')?.setValidators([Validators.required]);
      this.activationForm.get('unBlock')?.clearValidators();
      this.activationForm.get('block')?.clearValidators();
      this.activationForm.get('comments')?.clearValidators()
      this.activationForm.get('deactivate')?.clearValidators()
      this.activationForm.get('deactivateComments')?.clearValidators()
    }

    if (this.url === 'user-deactivate') {
      this.activationForm.get('deactivate')?.setValidators([Validators.requiredTrue]);
      this.activationForm.get('deactivateComments')?.setValidators([Validators.required]);
      this.activationForm.get('unBlock')?.clearValidators();
      this.activationForm.get('block')?.clearValidators();
      this.activationForm.get('unlock')?.clearValidators()
      this.activationForm.get('unlockComments')?.clearValidators()
      this.activationForm.get('comments')?.clearValidators()
    }
  }

  getBtnLable() {
    if (this.url === 'user-block') {
      this.btnLabel = 'Block User'
      this.iconClass = 'fas fa-ban'
    }
    if (this.url === 'user-unblock') {
      this.btnLabel = 'UnBlock User'
      this.iconClass = 'fas fa-user-check'
    }
    if (this.url === 'user-unlock') {
      this.btnLabel = 'Unlock User'
      this.iconClass = 'fas fa-lock-open'
    }
    if (this.url === 'user-deactivate') {
      this.btnLabel = 'Deactivate User'
      this.iconClass = 'fas fa-user-slash'
    }
  }

  onSubmit(data: any) {
    this.isSubmitted = true;
    if (this.activationForm.valid) {
      this.isSubmitted = false; 
      this.UpdateData(data)
    }
    else {
      console.log('error')
    }

  }


  UpdateData(data: any) {
    switch (data) {
      case 'user-block':
      case 'user-unblock':
        this.handleUserBlockUnblock(data);
        break;
      case 'user-unlock':
        this.handleUserUnlock();
        break;
      case 'user-deactivate':
        this.handleUserDeactivate();
        break;
      default:
        break;
    }
  }

  private handleUserBlockUnblock(action: string) {
    this.loader.show();
    const block = action === 'user-block';
    const blockStsParams = {
      "block": block,
      "unBlock": !block,
      "userID": this.userId,
      "comments": this.activationForm.value.comments,
    };

    this.restService.postUATData(blockStsParams, 'api/digital/core/User/UpdateUserBlockStatus').subscribe({
      next: (data) => {
        this.loader.hide();
        if (data.rcode === 200) {
          const dialogRef = this.dialog.open(MessageComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { userAction:block?'blocked':'unblocked'}
          });
          dialogRef.afterClosed().subscribe(()=>{
            this.activationForm.reset();
            history.back();
          });
        }else{
          this.errorHandling(data);
        }
      },
      error: (error: any) => {
        this.loader.hide();
        this.commonErrorHandling(error);
      }
    });
  }

  private handleUserUnlock() {
    this.loader.show()
    const params = {
      "userID": this.userId,
      "comments": this.activationForm.value.unlockComments
    };

    this.restService.postUATData(params, 'api/digital/core/User/UserUnlock').subscribe({
      next: (data) => {
        this.loader.hide()
        if (data.rcode == 200) {
          const dialogRef = this.dialog.open(MessageComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { userAction:'unLock'}
          });
          dialogRef.afterClosed().subscribe(()=>{
            this.activationForm.reset();
            history.back()
          });
        }
        else{
          this.errorHandling(data);
        }
      },
      error: (error: any) => {
        this.commonErrorHandling(error);
      }
    });
  }

  private handleUserDeactivate() {
    const params = {
      "userID": this.userId,
      "comments": this.activationForm.value.deactivateComments
    };

    this.restService.postUATData(params, 'api/digital/core/User/UserDeactivate').subscribe({
      next: (data) => {
        if (data.rcode == 200) {
          const dialogRef = this.dialog.open(MessageComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { userAction:'deactivate'}
          });
          dialogRef.afterClosed().subscribe(()=>{
            this.activationForm.reset();
            history.back()
          });
        }
        else{
          this.errorHandling(data);
        }
      },
      error: (error: any) => {
        this.commonErrorHandling(error);
      }
    });
  }

  errorHandling(data: any) {
    let a = data.rmsg[0].errorCode ?? 'ERROR'
    let err = this.translate.instant(a)
    let _dialogRef = this.dialog.open(MatDialogComponent, {
      panelClass: ['dialog-responsive'],
      disableClose: true,
      data: {
        secondary: true,
        transactionReference: data.rmsg[0].transactionReference ? data.rmsg[0].transactionReference : null,
        errorMessage: err
      }
    })
    _dialogRef.afterClosed().subscribe();
  }

  commonErrorHandling(error: any) {
    this.loader.hide();
    let errorCode = error.error.rmsg[0].errorCode ?? 'ERROR'
    this.commonService.apiErrorMessageDialog(error.error.trnID, errorCode);
  }
  goBack() {
    history.back();
  }
}
